<p *ngIf="message" class="app-error-message" role="alert">{{ message }}</p>
